/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

const Close = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
    className={className}
  >
    <path
      fill="currentColor"
      d="M15.586 8.121a3 3 0 00-4.243 0L10.12 9.343a3 3 0 000 4.243L28.036 31.5 10.12 49.414a3 3 0 000 4.243l1.222 1.222a3 3 0 004.243 0L33.5 36.964 51.414 54.88a3 3 0 004.243 0l1.222-1.222a3 3 0 000-4.243L38.964 31.5 56.88 13.586a3 3 0 000-4.243l-1.222-1.222a3 3 0 00-4.243 0L33.5 26.036 15.586 8.12z"
    ></path>
  </svg>
)

Close.propTypes = {
  className: PropTypes.string,
}

export default Close
